import { type Firestore, getFirestore } from "firebase/firestore";

import { getFirebaseApp } from "./firebase.ts";
import { runtimeConfig } from "./runtimeConfig.ts";

let _db: Firestore | null = null;

export function getDb(): Firestore {
  if (_db) return _db;
  // Target the named database for non-prod envs (e.g. "qc"); default for prod.
  const dbId = runtimeConfig().firestoreDatabaseId;
  _db =
    dbId && dbId !== "(default)"
      ? getFirestore(getFirebaseApp(), dbId)
      : getFirestore(getFirebaseApp());
  return _db;
}
